import React, { useEffect } from "react";
import { useStaticQuery, graphql } from "gatsby";
import { ThemeProvider } from "styled-components";
import SafeSiteSeoContext from "../context/SafeSiteSeoContext";
import { theme } from "../styles/theme";
import { QuoteBasketProvider } from "../context/QuoteBasketContext";
import { GlobalStyle } from "../styles/GlobalStyle";
import ReviewsProvider from "../context/ReviewContext";
import { ProductCategoryProvider } from "../context/ProductCategoryContext";
import { initMarketingSession } from "../utils/getMarketingData";

export default function Layout({ children, location }) {
  useEffect(() => {
    document.documentElement.classList.add('js-enabled')
    initMarketingSession();
  }, []);

  const {
    wp: { seo },
    site: { siteMetadata }
  } = useStaticQuery(graphql`
    query SiteInfoQuery {
      site {
        siteMetadata {
          siteUrl
        }
      }
      wp {
        seo {
          contentTypes {
            post {
              metaDesc
              metaRobotsNoindex
              schemaType
              title
            }
            page {
              metaDesc
              metaRobotsNoindex
              schemaType
              title
            }
          }
          webmaster {
            googleVerify
            yandexVerify
            msVerify
            baiduVerify
          }
          schema {
            companyName
            inLanguage
          }
          social {
            facebook {
              defaultImage {
                mediaItemUrl
                altText
              }
            }
            pinterest {
              metaTag
            }
            twitter {
              username
              cardType
            }
          }
        }
      }
    }
  `);

  return (
    <ReviewsProvider>
      <QuoteBasketProvider>
        <ThemeProvider theme={theme}>
          <SafeSiteSeoContext.Provider value={{ global: { ...seo, siteUrl: siteMetadata.siteUrl } }}>
            <ProductCategoryProvider key={location.pathname}>
              <GlobalStyle />
              <main>{children}</main>
            </ProductCategoryProvider>
          </SafeSiteSeoContext.Provider>
        </ThemeProvider>
      </QuoteBasketProvider>
    </ReviewsProvider>
  );
}
